import { render, staticRenderFns } from "./trainingVideoTypeManagement.vue?vue&type=template&id=7ec60753&scoped=true&"
import script from "./trainingVideoTypeManagement.vue?vue&type=script&lang=js&"
export * from "./trainingVideoTypeManagement.vue?vue&type=script&lang=js&"
import style0 from "./trainingVideoTypeManagement.vue?vue&type=style&index=0&id=7ec60753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec60753",
  null
  
)

export default component.exports